import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule, Routes } from "@angular/router";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { FormattingModule } from '@frontend/formatting';
import { CustomerFormModule } from '@frontend/components/customer-form/customer-form.module';
import { ToolbarComponent } from "@frontend/components/toolbar";
import { NewOfferComponent } from './new-offer.component';
import { AgentDataResolver } from './agent-data.resolver';
import { PropertyOverviewAgentComponent } from '@frontend/components/property-overview-agent';
import {TranslationFeatureModule} from "../../i18n/TranslationFeatureModule";

const routes: Routes = [{
  path: '',
  component: NewOfferComponent,
  resolve: { agent: AgentDataResolver },
}];

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        FormattingModule,
        MatSnackBarModule,
        CustomerFormModule,
        ToolbarComponent,
        PropertyOverviewAgentComponent,
        MatProgressSpinnerModule,
        RouterModule.forChild(routes),
        TranslationFeatureModule,
    ],
  exports: [RouterModule],
  declarations: [NewOfferComponent],
  providers: [],
})
export class NewOfferModule { }
